import { isSsr } from "libs/utils/logic/isServer"

export function scrollToAnchor(
  id: EScrolls | string,
  behavior?: ScrollBehavior
): boolean {
  const element = document.getElementById(id)

  if (id === "top") {
    window.scrollTo({ top: 0, behavior: behavior ?? "smooth" })
    return true
  }

  if (element) {
    const top = element.getBoundingClientRect().y - 130 + window.scrollY
    window.scrollTo({ top, behavior: behavior ?? "smooth" })
    return true
  }

  return false
}

export function scrollToTop() {
  if (isSsr()) {
    return
  }
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  })
}

export function scrollToId(id: string) {
  if (isSsr()) {
    return
  }

  const element = document.getElementById(id)
  if (element) {
    const offset = -60 // 60 pixels offset
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.scrollY + offset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  }
}

export enum EScrolls {
  everywhere = "everywhere",
  editor = "editor",
  faq = "faq",
  pricing = "pricing",
  blog = "blog",
  contact = "contact",
}
